const simpleBarTarget = document.querySelector('.p-top__postContents__topics');
//スマホの場合はスクロールバーを表示しない
if (simpleBarTarget) {
    let screenWidth = window.innerWidth;
    if(screenWidth > 768) {
        simpleBarTarget.classList.remove('js-simpleBar');
    }
}